import React, { Fragment } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function BillingBandLeftDaysSection(props) {
  return (
    <Fragment>
      {props.daysLeft <= props.showStartDate ? (
        <div className="billingbandinfo-wrapper">
          <span>{props.mainMessage}</span>
          <span
            onKeyPress={() => null}
            role="button"
            tabIndex="0"
            onClick={() => props.actionOnTextClick()}
            className="billingbandinfo-updgrade-link">
            {props.secondaryMessage}
          </span>
          <div className="billingbandinfo-cross-icon">
            {props.daysLeft <= props.cancleButtonVisibility ? null : (
              <FontAwesomeIcon
                icon={["far", "times"]}
                onClick={() => props.hideBillingBand()}
                className=""
              />
            )}
          </div>
        </div>
      ) : null}
    </Fragment>
  );
}



// WEBPACK FOOTER //
// ./src/components/BillingBandInfo/BillingBandLeftDaysSection.js